import { ATP_API_URL } from "../config/apiConfig";
import axios from "axios";
import { getAuthToken } from "../utils/index";

export const uploadDocumentAction = async ({
    file,
    documentRequirementId,
    entityId,
    entityDocumentId,
    actionType = "upload",
    actionTakenBy = "",
    onProgress,
}) => {
    try {
        const formData = new FormData();
        formData.append("EntityDocumentId", entityDocumentId || 0);
        formData.append("DocumentRequirementId", documentRequirementId);
        formData.append("EntityId", entityId);
        formData.append("ActionType", actionType);
        formData.append("ActionTakenBy", actionTakenBy);
        formData.append("File", file);

        const token = getAuthToken();
        const headers = { "Content-Type": "multipart/form-data" };
        if (token) headers["Authorization"] = `Bearer ${token}`;

        const response = await axios.post(ATP_API_URL.UPLOAD_DOCUMENT, formData, {
            headers,
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );
                if (onProgress) onProgress(percentCompleted);
            },
        });

        return { success: true, data: response.data };
    } catch (error) {
        console.error('[Upload] Failed:', error.message);
        return { success: false, error: error.response?.data || error.message };
    }
};
